import React, { useEffect, useState } from "react";
import { Button, FormControl, MenuItem, Select, LinearProgress } from "@mui/material";
import FunctionsData from "../../Functions/FunctionsData"; // assuming this handles API calls
import LandingSoldOutMessageCampaignsCommunity from "../LandingSoldOutMessageCampaignsCommunity";
import LandingSoldOutMessageCampaignsOutreach from "../LandingSoldOutMessageCampaignsOutreach";
export default function CommunityStep({ outreach,setcmpId, aStep, setAStep, setStep, accounts }) {
  const [dropdownOptions, setDropdownOptions] = useState([]); // To store dropdown values
  const [selectedValue, setSelectedValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSoldOut, setIsSoldOut] = useState(false); // New state variable
  const hostname = String(window.location.hostname).toLowerCase();

  // Prepare the group IDs as a string
  const groupIds = accounts[0].idTokenClaims.groups
    ? accounts[0].idTokenClaims.groups.join(",")
    : "";

  // Fetch the dropdown data
  useEffect(() => {
    setLoading(true);
    var tragetPortal = "community";
    if (hostname.includes("community")) {
      tragetPortal = "community";
    } 
    else if(hostname.includes("outreach") ){
      tragetPortal = "outreach";
    }else {
      tragetPortal = "inspectors";
    }
    FunctionsData.postDataReturn("/api/campaign/hubAdIds", { groups: groupIds, target: tragetPortal })
      .then((response) => {
        setDropdownOptions(response);
      })
      .catch((error) => {
        console.error("Error fetching dropdown data:", error);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
    setcmpId(event.target.value);

    // Find the selected option
    const selectedOption = dropdownOptions.find((option) => option.id === event.target.value);
    if (selectedOption) {
      setIsSoldOut(selectedOption.output.toLowerCase().includes("sold out"));
    } else {
      setIsSoldOut(false);
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: 20 }}>
      {loading && <LinearProgress style={{ margin: "20px 0" }} />}
      <FormControl fullWidth>
        <Select
          value={selectedValue}
          onChange={handleSelectChange}
          displayEmpty
          sx={{ marginBottom: 2 }}
          // Removed disabled={isSoldOut}
        >
          <MenuItem value="" disabled>
            Select the Campaign
          </MenuItem>
          {dropdownOptions.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.output}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {isSoldOut && (
  outreach
    ? <LandingSoldOutMessageCampaignsOutreach/>
    : <LandingSoldOutMessageCampaignsCommunity/>
)}
      {!isSoldOut && (
        <Button
          variant="contained"
          onClick={() => setAStep(aStep + 1)}
          disabled={!selectedValue}
        >
          Next
        </Button>
      )}
      <br />
      <Button
        onClick={() => {
          window.gtag("event", "action", {
            category: "User",
            action: "Clicked cancel application",
          });
          setStep(0);
        }}
        sx={{ margin: 1 }}
      >
        Cancel application
      </Button>
    </div>
  );
}

const ShowAddButton = () => (
  <div style={{ marginTop: 20 }}>
    This campaign has now sold out. Please email{" "}
    <a href="mailto:snipnchip@spca.nz" target="_blank" rel="noopener noreferrer">
      snipnchip@spca.nz
    </a>{" "}
    and our Desexing Team will be able to provide other options for you.
  </div>
);
